import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { EmptyStateRow, TableLoader, useStyles } from 'features/command-center/components';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { replaceQueryParams } from 'features/command-center/utils';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { UIStatus } from 'UI/constants/status';

export const ProductionTrackingByRecruiter = ({ columns, selectedTeam, queryParams }) => {
  const classes = useStyles();
  const updatedQueryParams = replaceQueryParams({
    queryParams,
    keyParam: 'teams',
    valueParam: selectedTeam
  });
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionTrackingByRecruiter}?${updatedQueryParams}`;

  const { state } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT
  });

  const data = state?.results ?? [];

  if (state.status === UIStatus.Loading) return <TableLoader colSpan={columns.length} />;

  if (!data || data.length === 0) return <EmptyStateRow colSpan={columns.length} />;

  return data
    .filter(row => !!row?.empNo)
    .map(row => (
      <TableRow key={row.empNo} hover>
        <TableCell />

        {columns.map(col => {
          if (col.options.display !== true) return null;

          return (
            <TableCell key={col.name}>
              <span className={classes.regularWeightRow}>
                {col?.options?.customBodyRender
                  ? col.options.customBodyRender(row[col.name])
                  : row[col.name]}
              </span>
            </TableCell>
          );
        })}
      </TableRow>
    ));
};
